<template>
  <div class="page">
    <div id="activeIs">
      <van-tabs
        @change="changeFn()"
        v-model="active"
        line-width="30"
        color="#DD2B1E"
        title-active-color="#DD2B1E"
        title-inactive-color="#999999"
      >
        <van-tab title="个人销售"></van-tab>
        <van-tab title="团队销售"></van-tab>
        <van-tab title="自购订单"></van-tab>
      </van-tabs>
    </div>

    <div v-if="view">
      <div v-if="data.length>0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="check"
        >
          <order-data :obj="data" :img="img" :active="active"></order-data>
        </van-list>
      </div>
      <div class="kong" v-if="data.length === 0">
        <img src="../img/kong.png" alt />
        <p style="color:rgba(153,153,153,1);">暂无订单</p>
      </div>
    </div>
    <footer-body></footer-body>
  </div>
</template>

<script>
import footerBody from "../../common/footer/footer";
import orderData from "../../common/orderData/orderData";
import getWXSign from "@/libs/wxSign";
import wxShare from "@/libs/wxShare";
export default {
  name: "orderHome",
  data() {
    return {
      active: 0,
      data: [],
      loading: false,
      finished: false,
      q: {
        page: 1,
        limit: 10,
        agentMemberId: 1,
        twoAgentMemberId: 0
      },
      check: false,
      view: false,
      img: require("../img/timg-21@2x.png"),
      channelType:""
    };
  },
  computed: {},
  components: {
    footerBody,
    orderData
  },
  filters: {},
  created() {
    this.active = Number(this.$route.query.type);
    if (this.active === 0) {
      this.q.agentMemberId = "1";
      this.q.twoAgentMemberId = "0";
      this.recruitTrackFn("personal");
    }

    if (this.active === 1) {
      this.q.agentMemberId = "0";
      this.q.twoAgentMemberId = "1";
      this.recruitTrackFn("team");
    }

    if (this.active === 2) {
      this.q.agentMemberId = "0";
      this.q.twoAgentMemberId = "0";
      this.recruitTrackFn("my");
    }
    this.list();
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    recruitTrackFn(page_attr) {
      
      this.$nextTick(() => {
        this.$trackFn.load("activeIs", "view_material", {
          // 曝光 - 埋点
          page_type: "order_list",
          card_type: "tab",
          material_type: "personal",
          material_position: 1
        });
        this.$trackFn.load("activeIs", "view_material", {
          // 曝光 - 埋点
          page_type: "order_list",
          card_type: "tab",
          material_type: "team",
          material_position: 2
        });
        this.$trackFn.load("activeIs", "view_material", {
          // 曝光 - 埋点
          page_type: "order_list",
          card_type: "tab",
          material_type: "my",
          material_position: 3
        });
      });
      // console.log(33339999, page_attr);
      if (!page_attr) {
        page_attr = "personal";
      }
      // console.log(88888, page_attr);
      let time1 = new Date().getTime();
      console.log(222);
      window.onbeforeunload = e => {
        let time2 = new Date().getTime();
        let dateDiff = (time2 - time1) / 1000;
        let page_type = "order_list";
        this.$trackFn.view("$pageview", {
          page_type: page_type,
          event_duration: dateDiff,
          page_attr: page_attr
        }); // 订单列表页 ——浏览埋点
        sessionStorage.setItem("pageType", page_type);
        // return "关闭提示";
      };
    },
    onLoad() {
      this.q.page++;
      this.list();
    },
    list() {
      this.$api.myOrder(this.q).then(res => {
        this.view = true;
        this.data = this.data.concat(res.data.body);
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (res.data.body.length < 10) {
          this.finished = true;
        }
        if (!this.active) {
          this.recruitTrackFn("");
        }
      });
    },

    changeFn() {
      this.data = [];
      this.q.page = 1;
      this.loading = false;
      this.finished = false;
      this.view = false;
      this.list();
      if (this.active === 0) {
        this.q.agentMemberId = "1";
        this.q.twoAgentMemberId = "0";
        this.changeFnTrackFn("personal", this.active);
      }

      if (this.active === 1) {
        this.q.agentMemberId = "0";
        this.q.twoAgentMemberId = "1";
        this.changeFnTrackFn("team", this.active);
      }

      if (this.active === 2) {
        this.q.agentMemberId = "0";
        this.q.twoAgentMemberId = "0";
        this.changeFnTrackFn("my", this.active);
      }
    },
    changeFnTrackFn(material_type, i) {
      this.$trackFn.send("click_material", {
        // 点击 - 埋点
        page_type: "order_list",
        card_type: "tab",
        material_type: material_type,
        material_position: i + 1
      });
    }
  }
};
</script>

<style scoped>
/deep/ .van-tab__text {
  font-size: 15px;
}

.pageview {
  background: #fff;
  height: 100vh;
  padding-bottom: 0;
}

.kong {
  text-align: center;
  padding-top: 300px;
  box-sizing: border-box;
  background: 100%;
  overflow: hidden;
}

.kong img {
  width: 270px;
  height: 270px;
  margin-bottom: 20px;
}
</style>
